import React from "react";
import { useSelector } from "react-redux";
import { CardProps, StateProps } from "../../store";
import * as S from "./styles";

const SubText = ({ id }: Pick<CardProps, "id">) => {
  const currentCard = useSelector((state: StateProps) =>
    state.cards.find((card) => card.id === id),
  );

  if (!currentCard || currentCard.subText === "" || !currentCard.subText) {
    return null;
  }

  let updatedText = currentCard.subText;

  // 조건 1: 텍스트가 <p><br></p>만 가질 때 ""로 치환
  if (/^<p( class="[^"]*")?><br><\/p>$/.test(updatedText)) {
    updatedText = "";
  } else {
    // 조건 2: <p class="..."><br></p>를 <article><br></article>로 치환
    updatedText = updatedText.replaceAll(
      /<p( class="[^"]*")?><br><\/p>/g,
      "<article><br></article>",
    );
  }

  return (
    <S.SubTextField
      dangerouslySetInnerHTML={{
        __html: updatedText,
      }}
    />
  );
};

export default SubText;
